import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ORIENTATION } from '../../../../cards/constants';
import usePrintProductConfiguration from '../../PrintProductConfigurator/usePrintProductConfiguration';
import DesignEditorLoadingIndicator from '../../../../../components/global/DesignEditor/components/DesignEditorLoadingIndicator';
import AccountCard from '../../../../cards/components/AccountCard';
import NativeActivityIndicator from '../../../../../components/global/NativeActivityIndicator';

const propTypes = {
  printProductId: PropTypes.string,
  printProductSizeId: PropTypes.string,
  orientation: PropTypes.oneOf(Object.values(ORIENTATION)),
  defaultAccountCard: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    is_album: PropTypes.bool,
  }),
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  photo: PropTypes.shape({
    id: PropTypes.string,
  }),
  onAccountCardUpdated: PropTypes.func,
  className: PropTypes.string,
};

const PrintProductGroupConfigurationItem = ({
  printProductId,
  printProductSizeId,
  printProductSizeServiceIds,
  orientation,
  defaultAccountCard,
  albumMembershipGroup,
  identity,
  photo,
  onAccountCardUpdated,
  className,
}) => {
  const {
    printProduct,
    printProductConfiguration: { selectedPrintProductSize },
    accountCardConfiguration: {
      loadingAccountCard,
      accountCard,
      onElementConfigurationChange,
      cardElementLoading,
    },
  } = usePrintProductConfiguration({
    printProductId,
    defaultPrintProductSizeId: printProductSizeId,
    defaultPrintProductSizeServiceIds: printProductSizeServiceIds,
    defaultPhoto: photo,
    defaultAccountCardId: defaultAccountCard?.id,
    defaultOrientation: orientation,
  });

  useEffect(() => {
    if (selectedPrintProductSize?.id) {
      onAccountCardUpdated({
        printProduct,
        printProductSize: selectedPrintProductSize,
        accountCard,
      });
    }
  }, [printProduct?.id, selectedPrintProductSize?.id, accountCard?.id]);

  const classes = classNames({
    'is-loading': loadingAccountCard,
    [className]: !!className,
  });

  if (!printProduct) {
    return <DesignEditorLoadingIndicator />;
  }

  if (loadingAccountCard && !accountCard) {
    return (
      <div className={classes}>
        <NativeActivityIndicator />
      </div>
    );
  }

  return (
    <Fragment>
      {accountCard && (
        <Fragment>
          <AccountCard
            className="print-product-configurator-account-card"
            onElementConfigurationChange={onElementConfigurationChange}
            accountCard={accountCard}
            cardElementLoading={cardElementLoading}
            photosContext={{
              identity_id: identity?.id,
              album_id:
                albumMembershipGroup &&
                (albumMembershipGroup.is_album
                  ? albumMembershipGroup.id
                  : undefined),
              album_folder_id:
                albumMembershipGroup &&
                (!albumMembershipGroup.is_album
                  ? albumMembershipGroup.id
                  : undefined),
              root_album_folder_id:
                albumMembershipGroup && albumMembershipGroup.is_album
                  ? albumMembershipGroup.album.root_album_folder?.id
                  : undefined,
              is_album_membership_group: !!albumMembershipGroup,
            }}
            allowPhotoChange={false}
            defaultPhoto={photo}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

PrintProductGroupConfigurationItem.propTypes = propTypes;

export default PrintProductGroupConfigurationItem;
